module.exports = __webpack_public_path__ + "img/2017.a424ba2d.svg";